





import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            toolbar: {
                title: 'Subscription Settings',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0
                    }
                ],
                right: []
            }
        }
    },
    async mounted() {
        //  If not subscription, do nothing
        if (!this.$store.getters.subscription) return

        //  Check if we have our upcoming invoice set
        const upcoming = this.$store.getters.selectedStripeInvoice

        //  Check if we are canceled
        const canceled = this.$store.getters.subscription.status === 'canceled'

        //  If we do NOT have our upcoming invoice AND we are NOT canceled, then get the invoice
        if (!upcoming && !canceled) {
            //  Get the latest invoice
            await this.$store.dispatch('stripeInvoiceFind', {
                tenant_id: this.$store.getters.tenant.id
            })
        }
    }
})
